export default __webpack_public_path__ + "static/media/Check_Mark.64012300.svg";